import { NumeroUtil } from "../util/numero.util";
import { StringUtil } from "../util/string.util";
import { EstiloSegmento } from "./estilo-segmento.model";

export class TipoSegmento {
    idTipoSegmento!: number;
    nomeTipoSegmento!: string;
    siglaTipoSegmento: string;
    estiloSegmento: EstiloSegmento | null;

    static getFunctionSortBy(campo: string): (a1: TipoSegmento, a2: TipoSegmento) => number {
        if (campo == 'idTipoAnotacao')
            return (a1: TipoSegmento, a2: TipoSegmento) => NumeroUtil.sort(a1.idTipoSegmento, a2.idTipoSegmento);

        if (campo == 'nome')
            return (a1: TipoSegmento, a2: TipoSegmento) => StringUtil.sort(a1.nomeTipoSegmento, a2.nomeTipoSegmento);

        if (campo == 'sigla')
            return (a1: TipoSegmento, a2: TipoSegmento) => StringUtil.sort(a1.siglaTipoSegmento, a2.siglaTipoSegmento);

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return (a1: TipoSegmento, a2: TipoSegmento) => 0;
    }
}
